import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { ErrorFallback } from "@/components/ErrorFallback";
import { isChunkLoadError } from "@/lib/chunk-reload";

// `errorElement` for the router root. A data router (createBrowserRouter)
// has its OWN error boundary around every route element, and it sits
// BELOW the Sentry boundary in main.tsx — so without this element every
// render-time throw inside a route, a rejected lazy import included, was
// painted by React Router's stock page ("Unexpected Application Error!")
// and never reached Sentry or our chunk-aware fallback (CLAUDE.md §117).
export function RouteErrorFallback() {
  const error = useRouteError();
  useEffect(() => {
    // Sentry's boundary never sees route errors; report the real ones
    // ourselves. A stale-chunk 404 is a deploy, not a crash — skip it.
    if (!isChunkLoadError(error)) Sentry.captureException(error);
  }, [error]);
  return (
    <ErrorFallback error={error} resetError={() => window.location.reload()} />
  );
}
